









import { Component, Vue, Prop } from 'vue-property-decorator';

import EmailIcon from '@/components/icons/Mail.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';

@Component({
  components: {
    EmailIcon,
    InputWrapper
  }
})
export default class InviteMailBox extends Vue {
  @Prop(String) label!: string;
  @Prop(String) email!: string;
}
